import { useTranslation } from "react-i18next";
import { SaveButton } from "@/shared/Components/Buttons";
import { getClassNames } from "@/shared/utils";
import styles from "./styles.module.scss";

type Props = {
  className?: string;
  onClick: () => void;
};

export const SettingsFormSubmitButton = ({ className, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <SaveButton className={getClassNames(styles.button, className)} onClick={onClick}>
      {t("common.change")}
    </SaveButton>
  );
};
